export default __webpack_public_path__ + "static/media/AveryAaronBurnsResume26.d73a3a5f.pdf";